<ui-dialog
    #officeModal
    header="import.mapValueTemplate.officeModalHeader"
    size="small"
    primaryButtonLabel="save"
    secondaryButtonLabel="cancel"
    secondaryButtonType="ghost"
    [form]="officeForm.form"
    (primaryButtonPressed)="createNewOffice(officeForm.office, officeForm)"
    (closing)="onCancel(officeForm)"
>
    <app-office-form #officeForm></app-office-form>
</ui-dialog>

<form class="form" (ngSubmit)="checkErrors()" #form="ngForm">
    <input type="hidden" required name="isMappingComplete" [(ngModel)]="mappingComplete" />
    <div class="app-grid">
        <div class="columns-9">
            <div
                *ngFor="let humiColumn of humiColumnService.getValueMappableHumiColumns()"
                class="mapping-sections-container"
            >
                <div class="mapping-section margin-bottom-3">
                    <div class="mapping-section-header margin-bottom-2">
                        <h4 class="margin-bottom-1">
                            @if (humiColumn.translatableLabel) {
                                {{ humiColumn.translatableLabel | translate }}
                            } @else {
                                {{ humiColumn.label }}
                            }
                        </h4>
                    </div>
                    <div class="mapping-table-header padding-x-5 padding-y-2">
                        <div class="app-grid">
                            <div class="columns-7 flex align-items-center">
                                {{ 'import.mapValueTemplate.importedValue' | translate }}
                                <ui-info
                                    class="margin-left-1"
                                    tooltipPosition="below"
                                    text="import.mapValueTemplate.importedValueNote"
                                ></ui-info>
                            </div>
                            <div class="columns-4">
                                {{ 'import.mapValueTemplate.importAs' | translate }}
                                <ui-info
                                    class="margin-left-1"
                                    tooltipPosition="below"
                                    text="import.mapValueTemplate.importAsNote"
                                ></ui-info>
                            </div>
                        </div>
                    </div>
                    <div class="mapping-table padding-x-5 padding-y-2">
                        <div *ngFor="let value of humiColumn.csvColumn.values" class="app-grid margin-bottom-2">
                            <div class="columns-4">
                                <div class="mapping-column">
                                    <div>{{ value }}</div>
                                </div>
                            </div>
                            <div class="columns-3 flex align-items-center">
                                <mat-icon svgIcon="chevronRight"></mat-icon>
                            </div>
                            <div class="columns-4">
                                <div class="mapping-column">
                                    <mat-form-field class="no-helpers no-labels">
                                        <mat-select
                                            #selectRef="ngModel"
                                            required
                                            [attr.name]="humiColumn.label + '_' + value"
                                            [name]="humiColumn.label + '_' + value"
                                            [ngModel]="humiColumn.csvColumn.valueMapping.get(value)"
                                            (selectionChange)="
                                                updateValueMapping($event, humiColumn, value, selectRef.control)
                                            "
                                            placeholder="{{
                                                'import.mapValueTemplate.mappingColumnPlaceholder' | translate
                                            }}"
                                        >
                                            <mat-option
                                                *ngFor="let option of humiColumn.options"
                                                [value]="option.value"
                                            >
                                                @if (option.translatableLabel) {
                                                    {{ option.translatableLabel | translate }}
                                                } @else {
                                                    {{ option.label }}
                                                }
                                            </mat-option>
                                            <mat-option *permission="allowedToCreate(humiColumn)" [value]="'new'">{{
                                                'import.mapValueTemplate.addNewColumn'
                                                    | translate: { columnLabel: humiColumn.label }
                                            }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="columns-3 flex">
            <app-unmatched-items
                itemType="Values"
                helperText="{{ 'import.mapValueTemplate.unmatchedHelperText' | translate }}"
                [unmatchedList]="humiColumnService.getUnmatchedColumnValueItems()"
            ></app-unmatched-items>
        </div>
    </div>
</form>
